import videoBackground from 'vidim'
import {
  __rem
} from './../config'

(function ($, w, d, undefined) {
  const userPosts = () => {
    const posts = d.querySelector('.user-posts')
    if (posts) {
      const items = posts.querySelectorAll('.item')
      const setHeight = () => items.forEach((current) =>
        current.style.height = __rem(current.offsetWidth)
      )

      setHeight()
      w.addEventListener('resize', setHeight)
    }
  }

  userPosts()

  // Force mute=1 dans les playerVars YouTube quand autoplay est demandé.
  // Vidim hardcode playerVars sans mute, or Chrome MEI bloque l'autoplay non muté → autoplay KO 1 visite/2.
  const patchYTPlayerForMutedAutoplay = () => {
    if (!w.YT || !w.YT.Player || w.YT.Player.__mutePatched) {
      return
    }
    const Original = w.YT.Player
    function Patched(el, opts) {
      if (opts && opts.playerVars && opts.playerVars.autoplay) {
        opts.playerVars.mute = 1
      }
      return new Original(el, opts)
    }
    Patched.prototype = Original.prototype
    Object.assign(Patched, Original)
    Patched.__mutePatched = true
    w.YT.Player = Patched
  }

  const background = () => {
    const youtube = d.getElementById('youtube-container')
    if (youtube) {
      const ytReadyInterval = setInterval(() => {
        if (w.YT && w.YT.Player) {
          patchYTPlayerForMutedAutoplay()
          clearInterval(ytReadyInterval)
        }
      }, 20)
      setTimeout(() => clearInterval(ytReadyInterval), 8000)

      const {
        dataset: {
          src,
          poster,
          params
        }
      } = youtube
      const attrs = JSON.parse(params)
      const video = new videoBackground('#youtube-container', {
        autoplay: attrs.autoplay || false,
        type: 'YouTube',
        src,
        poster
      })
      const playButton = d.getElementById('play-full')
      playButton.addEventListener('click', function (event) {
        video.play()
        this.classList.add('started')
        event.preventDefault()
        setTimeout(() => playButton.style.zIndex = '-1', 400)
      })
      if (attrs.autoplay) {
        playButton.style.zIndex = '-1'
      }
    }
  }

  background()

  // Mettre des blocs en full width
  const fullWidth = () => {
    const elements = d.querySelectorAll('.full-width-mobile')
    const handle = (current) => {
      const makeFullWidth = (element) => {
        const windowWidth = w.innerWidth
        const currentWidth = element.offsetWidth
        const left = (currentWidth - windowWidth) / 2
        if (windowWidth < 768) {
          element.style.width = __rem(windowWidth)
          element.style.left = __rem(left)
          element.style.position = 'relative'
        } else {
          element.style.width = 'initial'
          element.style.left = 0
        }
      }
      const onResize = () => {
        current.style.width = 'initial'
        makeFullWidth(current)
      }
      makeFullWidth(current)

      w.addEventListener('resize', onResize)
    }
    elements.forEach(handle)
  }

  fullWidth()

  $('.slick-carousel > div > div').slick({
    arrows: false,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: __rem(15)
        }
      }
    ]
  })

  $('.home .hebergement-carousel').slick({
    arrows: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: __rem(15)
        }
      }
    ]
  })

  // Gammes hors home : layout CSS pur (_gammes.scss) — Slick 1.8.1 casse le
  // scroll vertical sur Android Chrome (bug historique 2019, reproduit 2026)
}($, window, document))
